import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';

import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';

import productPlaceholder from '../../static/img/product_placeholder.jpg';


const styles = theme => ({
  card: {
    width: 220,
    margin: theme.spacing(2),
  },
  cardMedia: {
    backgroundSize: 'contain',
    height: 220,
  },
  cardActions: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
  },
  cardContent: {
    paddingBottom: 0,
  },
  price: {
    textAlign: 'right',
  },
});

function ProductCard(props) {
  const {
    classes,
    product,
    addButtonLoading,
    allowAdd,
    tooltipText,
  } = props;
  return (
    <Card className={classes.card}>
      <CardActionArea
        component={Link}
        to={'/shop/product/' + product.id}
      >
        <CardMedia
          component="img"
          alt={product.title}
          className={classes.cardMedia}
          height="180"
          image={product.images[0]
            ? product.images[0].original
            : productPlaceholder
          }
          title={product.title}
        />
      </CardActionArea>
      <CardContent className={classes.cardContent}>
        <Typography gutterBottom variant="subtitle1">
          {product.title}
        </Typography>
        <Typography className={classes.price} gutterBottom variant="body1">
          {'$' + product.price.incl_tax}
        </Typography>
      </CardContent>
      <Divider />
      <CardActions className={classes.cardActions}>
        <Button component={Link} to={'/shop/product/' + product.id} className={classes.button} variant="outlined" size="small">Details</Button>
        {allowAdd
          ? (
            <React.Fragment>
              {addButtonLoading === product.id
                ? <Button disabled className={classes.button} size="small" color="secondary" variant="contained">Adding..</Button>
                : <Button className={classes.button} size="small" color="secondary" variant="contained" onClick={e => props.addToCart(e, product)}>Add to Cart</Button>
              }
            </React.Fragment>
          )
          : (
            <Tooltip title={tooltipText}>
              <div>
                <Button disabled className={classes.button} size="small" color="secondary" variant="contained">Add to Cart</Button>
              </div>
            </Tooltip>
          )
        }
      </CardActions>
    </Card>
  );
}

ProductCard.propTypes = {
  classes: PropTypes.object.isRequired,
  product: PropTypes.object.isRequired,
  addButtonLoading: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.bool,
  ]).isRequired,
  allowAdd: PropTypes.bool.isRequired,
  addToCart: PropTypes.func.isRequired,
  tooltipText: PropTypes.string.isRequired,
};

export default withStyles(styles)(ProductCard);
